import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** v4.1.2: a page opened from the global search gets ?q=… - put it in the page's own search box. */
export default function useUrlQuery(apply) {
  const { search } = useLocation();
  useEffect(() => {
    const q = new URLSearchParams(search).get('q');
    if (q !== null) apply(q);
  }, [search]); // eslint-disable-line
}
